import { Injectable } from '@angular/core';
import { ServiceCurrentState, ServiceState, ServiceType } from '@core/services/models/service.interface';
import { SERVICES_CONFIG } from '@core/services/service-config';
import { ServiceConfigInterface } from '@core/services/models/service-config.interface';
import { Memomize } from '@helpers/decorators';

@Injectable({
    providedIn: 'root'
})
export class ServiceConfigService {
    public getName(type: ServiceType): string | null {
        return this.getConfigKey(type, 'name');
    }

    public getDescription(type: ServiceType): string | null {
        return this.getConfigKey(type, 'description');
    }

    public getLogo(type: ServiceType): string | null {
        return this.getConfigKey(type, 'logo');
    }

    public getCurrentState(state: ServiceState[] | null, type: ServiceType): ServiceCurrentState | null {
        if (!state || state.length === 0) {
            return null;
        }

        const config = SERVICES_CONFIG.find(config => config.type === type);

        if (!config?.availableStates) {
            return null;
        }

        const matchedStates = config.availableStates
            .filter(filteredState => state.includes(filteredState.type))
            .sort((a, b) => a.priority - b.priority);

        const topState = matchedStates[0];

        return topState
            ? {
                state: topState.type,
                color: topState.color,
                name: topState.name,
                description: topState.description,
                priority: topState.priority
            }
            : null;
    }

    @Memomize()
    private getConfigKey<T extends keyof ServiceConfigInterface>(
        type: ServiceType,
        key: T
    ): ServiceConfigInterface[T] | null {
        const config = SERVICES_CONFIG.find(config => config.type === type);

        if (!config || config[key] === undefined || config[key] === null) {
            return null;
        }

        return config[key];
    }
}
